import { render, staticRenderFns } from "./Rybelsus.vue?vue&type=template&id=137d271e&scoped=true&"
import script from "./Rybelsus.vue?vue&type=script&lang=js&"
export * from "./Rybelsus.vue?vue&type=script&lang=js&"
import style0 from "./Rybelsus.vue?vue&type=style&index=0&id=137d271e&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "137d271e",
  null
  
)

export default component.exports